"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _wolfy87Eventemitter = _interopRequireDefault(require("wolfy87-eventemitter"));

var _config = require("./config");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EVENT_NAME = 'RADIKS_STREAM_MESSAGE';

var Streamer =
/*#__PURE__*/
function () {
  function Streamer() {
    _classCallCheck(this, Streamer);
  }

  _createClass(Streamer, null, [{
    key: "init",
    value: function init() {
      var _this = this;

      if (this.initialized) {
        return this.socket;
      }

      var _ref = (0, _config.getConfig)(),
          apiServer = _ref.apiServer;

      var protocol = document.location.protocol === 'http:' ? 'ws' : 'wss';
      var socket = new WebSocket("".concat(protocol, "://").concat(apiServer.replace(/^https?:\/\//, ''), "/radiks/stream/"));
      this.emitter = new _wolfy87Eventemitter.default();
      this.socket = socket;
      this.initialized = true;

      socket.onmessage = function (event) {
        _this.emitter.emit(EVENT_NAME, [event]);
      };

      return socket;
    }
  }, {
    key: "addListener",
    value: function addListener(callback) {
      this.init();
      this.emitter.addListener(EVENT_NAME, callback);
    }
  }, {
    key: "removeListener",
    value: function removeListener(callback) {
      this.init();
      this.emitter.removeListener(EVENT_NAME, callback);
    }
  }]);

  return Streamer;
}();

exports.default = Streamer;

_defineProperty(Streamer, "initialized", void 0);

_defineProperty(Streamer, "socket", void 0);

_defineProperty(Streamer, "emitter", void 0);